(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["new-testimonials-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const swiperTestimonials = new Swiper('.swiper.testimonials', {
    slidesPerView: 1,
    spaceBetween: 8,
    breakpoints: {
      1024: {
        slidesPerView: 3,
        spaceBetween: 16
      }
    },
    speed: 400,
    mousewheel: {
      forceToAxis: true,
    },
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      renderBullet: function (index, className) {
        return '<span class="' + className + '"><span></span>' + "</span>";
      },
    },
    on: {
      init: function () {
        highlightNextNext(this); // call on init
      },
      slideChangeTransitionEnd: function () {
        highlightNextNext(this); // call on slide change
      },
    }
  });

  function highlightNextNext(swiper) {
 
    swiper.slides.forEach(slide => slide.classList.remove('next-next'));


    const activeSlide = [...swiper.slides].find(slide =>
      slide.classList.contains('swiper-slide-active')
    );

    if (activeSlide) {
      //let nextNext = activeSlide.nextElementSibling?.nextElementSibling;

      let nextNext = activeSlide;
let steps = 0;

while (nextNext && steps < 2) {
  nextNext = nextNext.nextElementSibling;
  if (nextNext && !nextNext.classList.contains('swiper-slide-blank')) {
    steps++;
  }
}

   
      if (!nextNext) {
        const index = [...swiper.slides].indexOf(activeSlide);
        const total = swiper.slides.length;
        const wrappedIndex = (index + 2) % total;
        nextNext = swiper.slides[wrappedIndex];
      }

      if (nextNext) {
        nextNext.classList.add('next-next');
      }
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-testimonials-support"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const swiperTestimonials = new Swiper('.swiper.testimonials', {
    slidesPerView: 1,
    spaceBetween: 8,
    breakpoints: {
      1024: {
        slidesPerView: 3,
        spaceBetween: 16
      }
    },
    speed: 400,
    mousewheel: {
      forceToAxis: true,
    },
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      renderBullet: function (index, className) {
        return '<span class="' + className + '"><span></span>' + "</span>";
      },
    },
    on: {
      init: function () {
        highlightNextNext(this); // call on init
      },
      slideChangeTransitionEnd: function () {
        highlightNextNext(this); // call on slide change
      },
    }
  });

  function highlightNextNext(swiper) {
 
    swiper.slides.forEach(slide => slide.classList.remove('next-next'));


    const activeSlide = [...swiper.slides].find(slide =>
      slide.classList.contains('swiper-slide-active')
    );

    if (activeSlide) {
      //let nextNext = activeSlide.nextElementSibling?.nextElementSibling;

      let nextNext = activeSlide;
let steps = 0;

while (nextNext && steps < 2) {
  nextNext = nextNext.nextElementSibling;
  if (nextNext && !nextNext.classList.contains('swiper-slide-blank')) {
    steps++;
  }
}

   
      if (!nextNext) {
        const index = [...swiper.slides].indexOf(activeSlide);
        const total = swiper.slides.length;
        const wrappedIndex = (index + 2) % total;
        nextNext = swiper.slides[wrappedIndex];
      }

      if (nextNext) {
        nextNext.classList.add('next-next');
      }
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-testimonials"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const swiperTestimonials = new Swiper('.swiper.testimonials', {
  centeredSlides: true,
    slidesPerView: 1,
    spaceBetween: 8,
    breakpoints: {
      1024: {
      centeredSlides: true,
        slidesPerView: 3,
        spaceBetween: 16
      }
    },
    speed: 400,
    mousewheel: {
      forceToAxis: true,
    },
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      renderBullet: function (index, className) {
        return '<span class="' + className + '"><span></span>' + "</span>";
      },
    },
    on: {
      init: function () {
        highlightNextNext(this); // call on init
      },
      slideChangeTransitionEnd: function () {
        highlightNextNext(this); // call on slide change
      },
    }
  });

  function highlightNextNext(swiper) {
 
    swiper.slides.forEach(slide => slide.classList.remove('next-next'));


    const activeSlide = [...swiper.slides].find(slide =>
      slide.classList.contains('swiper-slide-active')
    );

    if (activeSlide) {
      //let nextNext = activeSlide.nextElementSibling?.nextElementSibling;

      let nextNext = activeSlide;
let steps = 0;

while (nextNext && steps < 2) {
  nextNext = nextNext.nextElementSibling;
  if (nextNext && !nextNext.classList.contains('swiper-slide-blank')) {
    steps++;
  }
}

   
      if (!nextNext) {
        const index = [...swiper.slides].indexOf(activeSlide);
        const total = swiper.slides.length;
        const wrappedIndex = (index + 2) % total;
        nextNext = swiper.slides[wrappedIndex];
      }

      if (nextNext) {
        nextNext.classList.add('next-next');
      }
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rotating-sticker"] && !Shopify.designMode) return;
  try {
    

var LTEmblem = {
  init: function(el, str) {
    var element = document.querySelector(el);
    var text = str ? str : element.innerHTML;
    element.innerHTML = '';
    for (var i = 0; i < text.length; i++) {
      var letter = text[i];
      var span = document.createElement('span');
      var node = document.createTextNode(letter);
      var r = (360/text.length)*(i);
      var x = (Math.PI/text.length).toFixed(0) * (i);
      var y = (Math.PI/text.length).toFixed(0) * (i);
      span.appendChild(node);
      span.style.webkitTransform = 'rotateZ('+r+'deg) translate3d('+x+'px,'+y+'px,0)';
      span.style.transform = 'rotateZ('+r+'deg) translate3d('+x+'px,'+y+'px,0)';
      element.appendChild(span);
    }
  }
};

LTEmblem.init('.emblem');

  } catch(e) { console.error(e); }
})();
})();
